import React 		from 'react';
import PropTypes 	from 'prop-types';

//this.props.classes	: string of classes

export default class MultilineHiddenText extends React.Component 
{
	constructor(props) 
	{
		super(props);

		this.state =	{
							longText: 		false
						,	expandTerms:	this.props.isExpanded ? this.props.isExpanded : false
						, hasRendered: false
						};
	}

	componentDidMount() {
		this.setState({hasRendered: true});

		const siteLineHeight 	= 1.5;
		const smallSize 			= 12;
		const regularSize 		= 14;
		
		const lineHeight 	= siteLineHeight * (this.props.small ? smallSize : regularSize);
		const height 			= this.props.style == 'single-line' ? lineHeight * 1 : lineHeight * 7;

		if (this.text && this.text.offsetHeight > height && this.state.longText != true) {
			this.setState({longText: true});
		}
	}

	render() {
		const {classes = '', text, isExpanded = false, style, small} = this.props;

		return (
			<div className={classes + (small ? ' text--small' : '')}>
				<div className={"multiline-hidden-text " + (this.state.longText ? 'multiline-hidden-text--long' : '') + (this.state.expandTerms ? " multiline-hidden-text--expanded" : "") + (style == 'single-line' && this.state.hasRendered ? ' multiline-hidden-text--single-line' : '')} ref={text => this.text = text} dangerouslySetInnerHTML={{__html: text}}></div>
				{this.state.longText ? 
					<button className="btn btn--link l-margin-top" onClick={() => this.setState({expandTerms: !this.state.expandTerms})}>
						<i className={"l-margin-right--sm far " + (this.state.expandTerms ? 'fa-minus' : 'fa-plus')}/>{this.state.expandTerms ? 'Show less' : 'Show more'}
					</button>
					: 
					null
				}
			</div>
		);
	}
}

MultilineHiddenText.propTypes = {
		classes: PropTypes.string
	, text: PropTypes.string
	, isExpanded: PropTypes.bool
	, style: PropTypes.oneOf(['single-line', 'multiline'])
	, small: PropTypes.bool
}